// The PostHog destination for capnolog.com, as a compiled-in default.
//
// WHY A LITERAL KEY IS CORRECT HERE, AND IS NOT A LEAKED SECRET.
// `phc_…` is a PostHog PROJECT API KEY. PostHog documents it as a public,
// write-only ingestion token that is *meant* to ship inside a client bundle:
// it can only write events into this project, and it cannot read an event, a
// person, an insight, a flag definition, or a project setting. The key that
// can read is the PERSONAL API key, which lives in the macOS Keychain and is
// used only by scripts/posthog-web-funnel.mjs and scripts/posthog-provision.mjs
// — it must never appear in a `VITE_` variable or in this file.
//
// The same key is already compiled into two other Capnolog surfaces the same
// way: the phone (apps/mobile, from POSTHOG_API_KEY at build time) and the
// Chrome extension (apps/extension/vite.config.ts, `__POSTHOG_API_KEY__`).
// Baking it here is what makes the website's funnel work on a publish with no
// owner step at all — a build with no environment set still measures.
//
// OVERRIDES. `VITE_POSTHOG_KEY` and `VITE_POSTHOG_HOST` win when they are set
// (artifacts/web/.env.example documents both), so pointing a staging build, a
// local run, or a future dedicated web project somewhere else stays a build
// variable and not a code edit.
//
// MOVING THE WEBSITE TO ITS OWN POSTHOG PROJECT LATER: create the project, take
// its `phc_…`, and set `VITE_POSTHOG_KEY` on the Replit deployment — that one
// variable is the whole migration, because every web event already carries
// `surface: "web"` and nothing else in the site reads this file.

/**
 * The project this site writes into: the same Capnolog project the phone and
 * the extension use. Public by design — see the note above.
 */
export const DEFAULT_POSTHOG_KEY =
  "phc_zAoSLGy62CF4MKoSxvMLtiN7gUDBfiZ2GcK7srcCmGLG";

/**
 * The INGESTION host (`us.i.posthog.com`), not the app/API host
 * (`us.posthog.com`) the dashboard scripts talk to. US region, matching the
 * phone and the privacy page's "US host" sentence.
 */
export const DEFAULT_POSTHOG_HOST = "https://us.i.posthog.com";
